import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import URL from '../constants/ServerUrl';
import Navbar from './Navbar';
import SkeletonLoader from './Skeletos';


const RateChart = () => {
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');

  const navigator = useNavigate();
  const [rateChartData, setRateChartData] = useState([]);
  const [selectedRateChart, setSelectedRateChart] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("dairy-token")
  const [searchTerm, setSearchTerm] = useState('');
  const [IsFocus, setIsFocus] = useState(false);
  

  const handleSearchChange = (event) => {

    setSearchTerm(event.target.value);
    setIsFocus(true);
    if(event.target.value === ''){
      setIsFocus(false);
    }
  };

  const filteredRateCharts = searchTerm
    ? rateChartData.filter((chart) =>
        chart.rateChartName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : rateChartData;


  const fetchData = async () => {
    try {
      if (username) {
        setIsLoading(true);
        const response = await axios.get(`${URL}admin/${username}/ratelist`,{
          Authorization: `Bearer ${token}`,

        });
        setRateChartData(response.data);
        setIsLoading(false);
      }
    } catch (error) {

      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteRateChart = async (id) => {
    try {
      if (username) {
        const res = await axios.delete(`${URL}admin/${username}/ratelist/`,{
          Authorization: `Bearer ${token}`,
        });
        alert('Rate Chart Deleted Successfully');
        setModalVisible(false);
        fetchData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const rateChartItem = (data) => (
    <div key={data.id} className="border p-4 mb-4 rounded-lg shadow-md bg-white">
    <div className="text-lg font-bold mb-2">{data.rateChartName}</div>
    <div className="text-sm">Level {data.level}</div>
    <div className="text-sm text-gray-600">({data.category})</div>
    <div className="flex mt-2 space-x-4">
      <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:border-blue-300"
        onClick={() => navigator(`EditRateChart?username=${username}&id=${data._id}`)}
      
      >
        Edit
      </button>
      <button
        className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:border-red-300"
        onClick={() => {
          setSelectedRateChart(data);
          setModalVisible(true);
        }}
      >
        Delete
      </button>
    </div>
  </div>
  
  );

  return (


    <div className="flex flex-col items-center min-h-screen bg-green-100">
   <h1 className="text-2xl font-bold text-center text-red-600 mb-6 w-full p-4 border border-green-200 rounded-lg bg-blue-100">
  Rate Chart
</h1>
<div className="flex justify-between items-center mb-4">
<input
        type="text"
        placeholder="Search Rate Chart..."
        className="flex-grow border border-gray-300 p-2 mr-2"
        value={searchTerm}
        onChange={handleSearchChange}
      />



  
    <button
      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded self-start ml-4 mt-4"
      onClick={() => navigator(`AddRateChart?username=${username}`)}
    >
      Add Rate Chart
    </button>
  
</div>


    {IsFocus && filteredRateCharts.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 p-4 mt-4 justify-items-start w-full">
          {filteredRateCharts.map((data) => rateChartItem(data))}
        </div>
      )}
    {isLoading && (
      <div className="flex flex-1 justify-center items-center w-full mt-4">
        <div className="text-2xl">
          <SkeletonLoader />
        </div>
      </div>
    )}
  
    {!isLoading && !IsFocus && rateChartData.length  === 0 && (
      <div className="flex flex-1 justify-center items-center w-full mt-4">
        <div className="text-2xl">No Rate Chart Found</div>
      </div>
    )}
  
    {!isLoading && !IsFocus && rateChartData.length > 0 && (
      <div className="grid grid-cols-1 md:grid-cols-5 gap-8 p-4 mt-4 justify-items-start w-full">
        {rateChartData.map((data) => rateChartItem(data))}
      </div>
    )}
  
    {modalVisible && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
        <div className="bg-white p-4 rounded w-64">
          <div className="text-lg mb-2">Confirm Delete?</div>
          <div className="mb-2">{`Rate Chart: ${selectedRateChart?.rateChartName}`}</div>
          <div className="flex justify-between">
            <div
              className="cursor-pointer text-blue-500"
              onClick={() => setModalVisible(false)}
            >
              Cancel
            </div>
            <div
              className="cursor-pointer text-red-500"
              onClick={() => deleteRateChart(selectedRateChart?.id)}
            >
              Delete
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
  
  
  );
};

export default RateChart;
